import { Link } from 'app/shared/ui';

export const formTranslations = {
  disclaimer: (
    <>
      Weitere Informationen erhältst Du in unserer{' '}
      <Link
        to="https://policies.google.com/privacy"
        useRouter={false}
        target="_blank"
      >
        Datenschutzerklärung
      </Link>
      . Du kannst Dich jederzeit durch E-Mail an{' '}
      <Link
        useRouter={false}
        target="_blank"
        href="mailto:privacy@hey.car"
        rel="noopener noreferrer"
      >
        privacy@hey.car
      </Link>{' '}
      oder den Abmelde-Link in den Newsletter E-Mails wieder abmelden.
    </>
  ),
  title: 'Immer die neuesten Angebote',
  formText:
    'In unserem personalisierten E-Mail Newsletter senden wir dir regelmäßig Tipps zu deiner Autosuche sowie aktuelle Infos zu unseren Produkten und Aktionen.',
  userEmailError: 'E-Mail-Adresse wurde bereits registriert.',
  formButton: 'Anmelden',
};

export const successTranslations = {
  successMessage:
    'Danke für dein Interesse! Wir haben dir eine E-Mail geschickt. Bitte bestätige dort deine Anmeldung!',
  closeButton: 'Alles klar',
};
